/** Encounter status filter groups: a label key, English fallback, and comma-joined status values. */
export var ENCOUNTER_STATUS_GROUPS = [{
  labelKey: "status_scheduled",
  fallback: "Scheduled",
  value: "planned"
}, {
  labelKey: "status_ongoing",
  fallback: "Ongoing",
  value: "arrived,triaged,in-progress"
}, {
  labelKey: "status_completed",
  fallback: "Completed",
  value: "finished"
}, {
  labelKey: "status_cancelled",
  fallback: "Cancelled",
  value: "cancelled,onleave"
}, {
  labelKey: "status_unknown",
  fallback: "Unknown",
  value: "unknown"
}];